import type {
  NormalizedDividendQuality,
  Period,
} from '../../../types/portfolioDividend';
import { formatCurrencyToScaleTruncated } from '@/utilities/portfolio/formatValue';

export const columnStackKeys = ['High', 'Medium', 'Low'];

export const KEYS_MAP = {
  'Last 12m': 'last1y',
  'Next 12m': 'next1y',
  '+2 year': 'next2y',
  '+3 year': 'next3y',
};

export const keys = Object.keys(KEYS_MAP);

export const getKeyByPeriod = (period: Period) => {
  return keys.find((k) => KEYS_MAP[k] === period);
};

export const getEntities = (data: NormalizedDividendQuality) => {
  return keys.reduce((acc, key) => {
    const dataKey = KEYS_MAP[key];
    return {
      ...acc,
      [key]: [
        data[dataKey]?.highScore?.totalPayment ?? null,
        data[dataKey]?.mediumScore?.totalPayment ?? null,
        data[dataKey]?.lowScore?.totalPayment ?? null,
      ],
    };
  }, {});
};

export const getEntitiesFormatted = (
  data: NormalizedDividendQuality,
  currencyISO: string
) => {
  return keys.reduce((acc, key) => {
    const dataKey = KEYS_MAP[key];
    return {
      ...acc,
      [key]: formatCurrencyToScaleTruncated(
        data[dataKey].totalPayment,
        currencyISO
      ),
    };
  }, {});
};
